// extracted by mini-css-extract-plugin
export default {"side-nav":"SideNav_side-nav__dhtup","nav-wrapper":"SideNav_nav-wrapper__OldO2","nav-listLinks":"SideNav_nav-listLinks__VoY1-","nav-listSettings":"SideNav_nav-listSettings__hqIqy"};